import { useAuth } from '../context/AuthContext';

export function usePremium() {
  const { user } = useAuth();
  const isPremium = user?.is_premium === true && user?.premium_status === 'active';
  const isPending = user?.premium_status === 'pending';
  const isExpired = user?.premium_status === 'expired';
  return { isPremium, isPending, isExpired, premiumStatus: user?.premium_status || 'none' };
}
